module.exports = __webpack_public_path__ + "img/q1@2x.571b4deb.png";